<template>
	<modal ref="modal" size="modal-xl">
		<template #title>Beneficiaries</template>
		<template #body>
			<div v-if="beneficiaries.length > 0" class="table-responsive">
				<table
					class="table table-striped table-borderless table-hover table-vcenter"
				>
					<thead>
						<tr>
							<th>Name</th>
							<th>Birthday</th>
							<th>Relationship</th>
						</tr>
					</thead>
					<tbody class="fs-sm">
						<tr v-for="beneficiary in beneficiaries" :key="beneficiary.id">
							<td>{{ beneficiary.fname }} {{ beneficiary.lname }}</td>
							<td>{{ beneficiary.birthday }}</td>
							<td>{{ beneficiary.relationship }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else class="alert alert-warning">
				<p class="mb-0">NO BENEFICIARIES FOUND</p>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'

export default {
	props: {
		beneficiaries: Object,
	},
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
